import React from "react";
import type { FC } from "react";

import { ButtonInline } from "../../../../../components/ButtonInline";
import { useInputStore } from "../../store/inputStore";
import { useCoreInputTextStore } from "../../store/store";
import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextRightProps } from "../../types";

import classes from "./CoreInputTextRight.styl";

const CORE_INPUT_TEXT_RIGHT_DELETE_TEST_ID =
    createTestIdForCoreInputTextElement("button-inline-delete");

const INPUT_TEXT_RIGHT_TEST_ID = createTestIdForCoreInputTextElement("right");

export const CoreInputTextRight: FC<InputTextRightProps> = (props) => {
    const { state } = useCoreInputTextStore();
    const { onClear } = useInputStore();

    const { content, clearInputAriaLabel, children, ...restProps } = props;

    const customContent = content === "custom" ? children : null;
    const deleteButtonState =
        state === "disabled" || state === "readonly" ? "disabled" : undefined;

    return (
        <div className={classes["right"]} data-tsid={INPUT_TEXT_RIGHT_TEST_ID}>
            {customContent}
            {content === "delete" && (
                <ButtonInline
                    {...restProps}
                    view="tertiary"
                    onClick={(e) => {
                        onClear();
                        props.onClick?.(e);
                    }}
                    size="24"
                    state={deleteButtonState}
                    aria-label={clearInputAriaLabel}
                    data-tsid={CORE_INPUT_TEXT_RIGHT_DELETE_TEST_ID}
                >
                    <ButtonInline.RightIcon icon="glyph_close_circle_filled_24+" />
                </ButtonInline>
            )}
        </div>
    );
};

CoreInputTextRight.displayName =
    createDisplayNameForCoreInputTextElement("InputText");

export default CoreInputTextRight;
